import { useEffect, useRef, useState } from "react";

const JitsiEmbed = () => {
    const [room, setRoom] = useState("");
    const [name, setName] = useState("");
    const jitsiContainerRef = useRef(null);
    const [meetingLink, setMeetingLink] = useState("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const roomFromUrl = params.get("room");

        if (roomFromUrl) {
            setRoom(roomFromUrl);
            setMeetingLink(`${window.location.origin}/jitsi?room=${roomFromUrl}`);
            const userFromUrl = params.get("user");
            if (userFromUrl) {
                setName(userFromUrl);
            } else {
                // Default: admin
                setName("Admin");
            }
        }
    }, []);

    const createRoom = (patientName = "Namapasien") => {
        const random = Math.random().toString(36).substring(2, 8);
        setRoom("myroom-" + random);
        setMeetingLink(`${window.location.origin}/jitsi?room=myroom-${random}&user=${patientName}`);
        setName("Admin");
    };

    useEffect(() => {
        if (!room) return;

        const domain = "meet.jit.si";

        const options = {
            roomName: room,
            parentNode: jitsiContainerRef.current,
            width: "100%",
            height: "97vh",
            userInfo: {
                displayName: name || "Guest",
            },
            configOverwrite: {
                startWithAudioMuted: true,
                startWithVideoMuted: false,
                prejoinPageEnabled: false,
                enableWelcomePage: false,
                requireDisplayName: false,
                enableUserRolesBasedOnToken: false,
            },
            interfaceConfigOverwrite: {
                DISABLE_JOIN_LEAVE_NOTIFICATIONS: true,
                TOOLBAR_BUTTONS: [
                    "microphone",
                    "camera",
                    "fullscreen",
                    "hangup",
                    "chat",
                ],
            },
        };

        const api = new window.JitsiMeetExternalAPI(domain, options);

        return () => api.dispose();
    }, [room, name]);

    return (
        <div  >
            {/* <h2>Jitsi Custom</h2> */}

            {/* <input
                placeholder="Masukkan nama"
                value={name}
                onChange={(e) => setName(e.target.value)}
                style={{ marginRight: 10, padding: 5 }}
            /> */}

            {/* <button onClick={createRoom}>Start Meeting</button> */}

            {/* {meetingLink && (
                <div style={{ marginTop: 15 }}>
                    <p>Link Meeting:</p>
                    <input
                        value={meetingLink}
                        readOnly
                        style={{ width: "100%", padding: 5 }}
                    />
                    <button
                        onClick={() => navigator.clipboard.writeText(meetingLink)}
                        style={{ marginTop: 5 }}
                    >
                        Copy Link
                    </button>
                </div>
            )} */}

            <div ref={jitsiContainerRef}   />
        </div>
    );
};

export default JitsiEmbed;